import { ApiDateSchema, ProductsUsageReportSchema } from '@weft/types';
import { oz } from '@weft/utils';

export const GetProductsUsageReportResponseSchema = oz.object({
  report: ProductsUsageReportSchema,
  creationDate: ApiDateSchema,
  startDate: ApiDateSchema.optional(),
  endDate: ApiDateSchema.optional(),
}).openapi('GetProductsUsageReportResponseSchema');

export type GetProductsUsageReportResponsePayload = oz.TypeOf<typeof GetProductsUsageReportResponseSchema>;